'use strict';

angular.module('TurneroApp').component('coEncuestasHistorial', {
    bindings: {
        ctrlPadre: '='
    },
    controller: [
        'encuestasService',
        'utilsService',
        'TurneroAppConstant',
        function (encuestasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.Encuesta = null;
            ctrl.Historial = [];

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadHistorial = function (item) {
                    ctrl.limpiarMemoria();
                    ctrl.Encuesta = item;

                    if (ctrl.Encuesta && ctrl.Encuesta.Id_Encuesta) {
                        ctrl.cargarGrilla();
                    }
                }
            }

            //Paginacion
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.limpiarMemoria = function () {
                ctrl.Historial = [];
            }

            ctrl.cargarGrilla = function () {
                if (ctrl.Encuesta.Id_Encuesta) {
                    utilsService.swalTitle('Cargando Información', 'info')
                    encuestasService.Get_Historial({
                        'filtro.Id_Encuesta': ctrl.Encuesta.Id_Encuesta,
                        'filtro.Nro_Pagina': ctrl.query.page,
                        'filtro.Tam_Pagina': ctrl.query.limit
                    }).$promise.then(function (resultado) {
                        ctrl.Historial = resultado.Data;
                        ctrl.pagination.total = resultado.Paging.Reg_Totales;
                        swal.close();
                    }).catch(function (error) {
                        swal.close()
                        utilsService.errores(error);
                    })
                }
            }

            ctrl.volver = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./encuestasHistorial.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasHistorialComponent.js